<template>
  <div class="flex flex-col min-h-screen overflow-hidden">
    <!-- Site header -->
    <Header />

    <!-- Page content -->
    <main class="flex-grow">
      <HeroHome />
      <Message />
      <Services />
      <Profiles />
      <Contact />
    </main>

    <!-- Site footer -->
    <Footer />
  </div>
</template>

<script>
import Header from "./../partials/Header.vue"
import HeroHome from "./../partials/HeroHome.vue"
import Message from "./../partials/Message.vue"
import Services from "./../partials/Services.vue"
import Profiles from "./../partials/Profile.vue"
import Contact from "./../partials/Contact.vue"
import Footer from "./../partials/Footer.vue"

export default {
  name: "Home",
  components: {
    Header,
    HeroHome,
    Message,
    Services,
    Profiles,
    Contact,
    Footer,
  },
}
</script>
